import React from 'react'

import { LinkContainer } from './Link.styles'

interface ILink {
  onClick?: () => void
  children: React.ReactNode
  color?: string
}

export const Link = ({ onClick, children, color }: ILink) => {
  return (
    <LinkContainer color={color} onClick={onClick}>
      {children}
    </LinkContainer>
  )
}
